import Modal from '@/fsd/shared/ui/Modal/Modal';
import styles from './MutualSettlementsModal.module.scss';
import MutualSettlementsAlert from '../MutualSettlementsAlert/MutualSettlementsAlert';
import { mutualSettlementsStore } from '../../model/store/MutualSettlementsStore';
import { observer } from 'mobx-react-lite';

const MutualSettlementsModal = observer(() => {
  console.log(
    'MutualSettlementsModal - rendering. selectedId:',
    mutualSettlementsStore.data.selectedId
  );
  return (
    <Modal
      showModal={Boolean(mutualSettlementsStore.data.selectedId)}
      setShowModal={(show) => {
        if (!show) mutualSettlementsStore.setSelectedId(undefined);
      }}
      showCloseButton
      className={styles.modal}
      classNameClose={styles.close}
      height="fit-content"
      size="large"
    >
      <MutualSettlementsAlert id={mutualSettlementsStore.data.selectedId} />
    </Modal>
  );
});

export default MutualSettlementsModal;
